class GoDarkCountdown extends HTMLElement {
  constructor() {
    super()

    this.now = this.getAttribute('data-time-now')
    this.until = this.getAttribute('data-time-until')
    this.updateTime = this.querySelector('.time')

    this.initialiseGoDarkCountdown()
  }

  initialiseGoDarkCountdown() {
    setInterval(() => {
      this.difference()
    }, 1000)
  }

  difference() {
    const until = this.until
    const now = Math.round(new Date().getTime() / 1000)
    const gap = until - now
    const time = this.convertSeconds(gap)

    this.formatAndPlaceTime(time)
  }

  convertSeconds(totalSeconds) {
    const days = Math.floor(totalSeconds / (24 * 60 * 60))
    totalSeconds %= (24 * 60 * 60);

    const hours = Math.floor(totalSeconds / (60 * 60))
    totalSeconds %= (60 * 60);

    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60

    return {
      days,
      hours,
      minutes,
      seconds,
    }
  }

  formatAndPlaceTime(time) {

    let timeString = ''

    if (time.days > 0) {
      timeString = `${time.days} day${time.days > 1 ? 's' : ''}`
    } else {
      if (time.hours > 0) {
        timeString += `${time.hours} hr${time.hours !== 1 ? 's' : ''}, `
      }
      if (time.minutes > 0) {
        timeString += `${time.minutes} min${time.minutes !== 1 ? 's' : ''}, `
      }
      if (time.seconds > 0) {
        timeString += `${time.seconds} sec${time.seconds !== 1 ? 's' : ''}`
      }
    }

    timeString = timeString.trim().replace(/,$/, '')

    // eslint-disable-next-line eqeqeq
    if (timeString != '') {
      this.updateTime.textContent = timeString
    } else {
      // fallback messaging... 
      this.textContent = 'Refresh your screen'
    }

    // this.updateTime.textContent = `${time.days} days, ${time.hours} hrs, ${time.minutes} mins, ${time.seconds} secs`
  }

}

customElements.define('go-dark-countdown', GoDarkCountdown)
